import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {Tag} from '../shared/Tag';
import {TagCategory} from '../shared/TagCategory';
import {MiniBookAdminService} from './mini-book-admin.service';

export class TagsService {

  constructor(private http: HttpClient, private adminService: MiniBookAdminService) { }

  getTags(): Observable<Tag[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/tags`).pipe(
      map<any[], Tag[]>(data => data.map(value => Tag.createFromJson(value)))
    );
  }

  createTag(tag: Tag): Observable<Tag> {
    return this.http.post<any>(`${this.adminService.tenant}/tags`, tag.toJson()).pipe(
      map<any, Tag>(data => Tag.createFromJson(data))
    );
  }

  getTag(id: number): Observable<Tag> {
    return this.http.get<any>(`${this.adminService.tenant}/tags/${id}`).pipe(
      map<any, Tag>(data => Tag.createFromJson(data))
    );
  }

  updateTag(id: number, tag: Tag): Observable<Tag> {
    return this.http.put<any>(`${this.adminService.tenant}/tags/${id}`, tag.toJson()).pipe(
      map<any, Tag>(data => Tag.createFromJson(data))
    );
  }

  deleteTag(id: number): Observable<void> {
    return this.http.delete<void>(`${this.adminService.tenant}/tags/${id}`);
  }

  getTagCategories(): Observable<TagCategory[]> {
    return this.http.get<any[]>(`${this.adminService.tenant}/tagCategories`).pipe(
      map<any[], TagCategory[]>(data => data.map(value => TagCategory.createFromJson(value)))
    );
  }

  createTagCategory(tag: TagCategory): Observable<TagCategory> {
    return this.http.post<any>(`${this.adminService.tenant}/tagCategories`, tag.toJson()).pipe(
      map<any, TagCategory>(data => TagCategory.createFromJson(data))
    );
  }

  getTagCategory(id: number): Observable<TagCategory> {
    return this.http.get<any>(`${this.adminService.tenant}/tagCategories/${id}`).pipe(
      map<any, TagCategory>(data => TagCategory.createFromJson(data))
    );
  }

  updateTagCategory(id: number, tag: TagCategory): Observable<TagCategory> {
    return this.http.put<any>(`${this.adminService.tenant}/tagCategories/${id}`, tag.toJson()).pipe(
      map<any, TagCategory>(data => TagCategory.createFromJson(data))
    );
  }

  deleteTagCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.adminService.tenant}/tagCategories/${id}`);
  }
}
